export default __webpack_public_path__ + "static/media/barraDeProgresso.51da0eed.png";